import WebAnalytics from '@lendi/analytics-web';
import WebAnalyticsV3 from '@lendi/analytics-web-v3';

import { getBrandSpecificValue } from '../brand';

const writeKey =
  getBrandSpecificValue({
    lendi: process.env.REACT_APP_SEGMENT_ID,
    aussie: process.env.REACT_APP_AUSSIE_SEGMENT_ID,
  }) || '';

const writeKeyV3 =
  getBrandSpecificValue({
    lendi: process.env.REACT_APP_SEGMENT_ID_V3,
    aussie: process.env.REACT_APP_AUSSIE_SEGMENT_ID_V3,
  }) || '';

const lendiAnalytics = (analyticsWebV4: boolean) => {
  //  Need to return a mock during test as WebAnalytics lib throws immediately if an invalid key is provided.
  // For some reason WebAnalytics is instaitated before Jest WebAnalytics mock come into play.
  if (process.env.NODE_ENV === 'test') {
    return {
      trackEvent: () => {},
      trackPage: () => {},
      identify: () => {},
    };
  }

  return analyticsWebV4 ? new WebAnalytics({ writeKey }) : new WebAnalyticsV3({ writeKey: writeKeyV3 });
};
export { lendiAnalytics };
